import { useLingui } from '@lingui/react';
import { styled } from 'styled-components';
import { classic } from '~/themes/classic';

export function Loading() {
  const { i18n } = useLingui();
  return (
    <Container>
      <span>{i18n._('common.loading')}</span>
    </Container>
  );
}

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 14px;
  pointer-events: none;
  user-select: none;
  width: 100%;

  & > span {
    color: ${classic.token?.colorText};
    font-size: 1.3rem;
    font-family: 'Riffic Free', sans-serif;
    font-weight: bold;
  }
`;
